// Header Component for Online Ordering
import React from 'react';

export function Header({ 
  venue, 
  settings, 
  cartCount, 
  onCartClick, 
  isOpen,
  showChangeLocation,
  onChangeLocation 
}) {
  const logoUrl = settings?.headerLogo || settings?.orderLogo;
  const venueName = settings?.venueName || venue?.venuename || 'Restaurant';
  const phone = settings?.phone || '';

  return (
    <header className="header">
      <div className="header__container">
        <div className="header__brand">
          {logoUrl ? (
            <img 
              src={logoUrl} 
              alt={venueName} 
              className="header__logo"
            />
          ) : (
            <h1 className="header__title">{venueName}</h1>
          )}
          
          {/* Show location name and change button for multi-venue groups */}
          {showChangeLocation && (
            <button 
              className="header__location-btn"
              onClick={onChangeLocation}
              title="Change location"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2a8 8 0 0 0-8 8c0 5.4 7 12 8 12s8-6.6 8-12a8 8 0 0 0-8-8z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              <span className="header__location-name">
                {venue?.city || 'Location'}
              </span>
              <svg className="header__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
          )}
        </div>

        <div className="header__info">
          {!isOpen && (
            <span className="header__status header__status--closed">
              Currently Closed
            </span>
          )}
          {isOpen && (
            <span className="header__status header__status--open">
              Open for Orders
            </span>
          )}
        </div>

        <div className="header__actions">
          {phone && (
            <a href={`tel:${phone}`} className="header__phone">
              <svg className="header__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
              <span className="header__phone-text">{phone}</span>
            </a>
          )}

          <button className="header__cart-btn" onClick={onCartClick}>
            <svg className="header__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="9" cy="21" r="1"/>
              <circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            {cartCount > 0 && (
              <span className="header__cart-count">{cartCount}</span>
            )}
          </button>
        </div>
      </div>
      
      <style>{`
        .header__location-btn {
          display: flex;
          align-items: center;
          gap: 0.375rem;
          padding: 0.375rem 0.75rem;
          margin-left: 0.75rem;
          background: var(--primary-light, rgba(37, 99, 235, 0.1));
          border: 1px solid var(--primary, #2563eb);
          border-radius: 20px;
          color: var(--primary, #2563eb);
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .header__location-btn:hover {
          background: var(--primary, #2563eb);
          color: white;
        }
        
        .header__location-btn svg {
          width: 16px;
          height: 16px;
        }
        
        .header__chevron {
          width: 14px;
          height: 14px;
        }
        
        .header__location-name {
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        
        @media (max-width: 640px) {
          .header__location-name {
            display: none;
          }
          
          .header__location-btn {
            padding: 0.375rem;
            margin-left: 0.5rem;
          }
        }
      `}</style>
    </header>
  );
}

export default Header;
